/* ==========================================================================
   DIREVULF — home-future.js
   Loaded only by sections/home-future.liquid. One job: the first time a
   section head scrolls into view, mark it .dvh-in so its red line draws in
   (assets/home-future.css). Skipped entirely when the shopper has asked for
   less motion or the browser has no IntersectionObserver — the line is then
   drawn from the start.
   ========================================================================== */
(function () {
  'use strict';
  var html = document.documentElement;
  if (!/\bdvh-lines\b/.test(html.className)) return;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (calm || !('IntersectionObserver' in window)) return;

  function heads() {
    return Array.prototype.slice.call(document.querySelectorAll('body.template-index .dv-rail__head:not(.dvh-in)'));
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('dvh-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

  function watch() { heads().forEach(function (h) { io.observe(h); }); }

  html.classList.add('dvh-motion');
  watch();

  /* Theme editor: a section re-rendered in place brings a fresh head. */
  document.addEventListener('shopify:section:load', watch);
})();
